// Thin wrapper that mounts <BeginnerShell /> inside an error boundary.
// Lives separate from App.tsx so the boundary can wire its recovery
// callbacks (`exit`, `reset`) into the same `useBeginnerMode` store the
// shell reads from — preserving "Restart" / "Exit guided mode" actions
// even when the shell itself just crashed.
import BeginnerShell from "./BeginnerShell";
import BeginnerShellErrorBoundary from "./BeginnerShellErrorBoundary";
import { useBeginnerMode } from "@/hooks/useBeginnerMode";

const BeginnerShellWithBoundary = () => {
  const { exit, reset } = useBeginnerMode();
  return (
    <BeginnerShellErrorBoundary onExit={exit} onReset={reset}>
      <BeginnerShell />
    </BeginnerShellErrorBoundary>
  );
};

export default BeginnerShellWithBoundary;